module.exports = __webpack_public_path__ + "static/img/14000753.c79d3c30.png";